import faq from '~/languages/en/help/faq';
import delivery from '~/languages/en/help/delivery';
import pickup from '~/languages/en/help/pickup';
import { HELP_CARDS as cards } from '~/utils/help.js';

export default {
  title: 'Help Centre',
  faq,
  delivery,
  pickup,
  cards,
  extra: {
    help_item: {
      index: 'Step',
    },
  },
  social: SOCIAL_ITEMS_FORM,
  form: {
    title: 'Contact our team',
    description: {
      base: 'Need help or have a question about your prescription order? Please contact our friendly customer service team directly.',
      extra: 'Just like our delivery, we aim to solve things for you speedy quick! Our team works 6 days a week, Monday to Friday 09:00-19:00 and Saturday 09:00-17:00',
    },
    inputs: {
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      contact_number: 'Contact number',
      message: 'Your enquiry',
    },
    buttons: {
      submit: {
        default: 'Submit',
        done: 'Submitted',
      },
    },
  },
};
